import { Container } from 'pixi.js';
import type { ResourceMap } from '../app/resources/types';
import type { SpeechBubbleConfig } from './SpeechBubbleView';
import { SpeechBubbleView } from './SpeechBubbleView';
import { createInventoryItemViews } from './InventoryItemAmountView';
import { centerElements } from '../game/utils/centerElements';

interface RewardBubbleConfig {
  pointer: SpeechBubbleConfig['pointer'];
  rewards: ResourceMap;
}

export class RewardBubbleView extends Container {
  private readonly bubbleView: SpeechBubbleView;

  constructor(config: RewardBubbleConfig) {
    super();

    const width = 120 + (Object.keys(config.rewards).length - 1) * 110;

    this.bubbleView = new SpeechBubbleView({
      pointer: config.pointer,
      body: { width, height: 110 },
    }).props({
      parent: this,
    });

    this.addRewards(config.rewards);
  }

  private addRewards(rewards: ResourceMap): void {
    centerElements(
      createInventoryItemViews(rewards).map((view) => view.props({ parent: this.bubbleView.getContentContainer() })),
      20,
    );
  }

  public destroy(): void {
    super.destroy({ children: true });
  }
}
